// Gemeinsame Bausteine der Verkaufs-Verträge. Mengen „im Gebinde“ stehen in Tausendstel des genannten Gebindes
// (1 Kasten = 1000), Bestände in Tausendstel der BASISEINHEIT (1 Flasche = 1000). Geld in Cent, Sätze in Basispunkten.
import { zId } from '@shared/ids'
import { z } from 'zod'

export {
  CONSIGNMENT_DELIVERY_TYPE,
  CONSIGNMENT_RETURN_TYPE,
  DELIVERY_TYPE,
  ORDER_TYPE,
  QUOTE_TYPE,
  RETURN_TYPE,
  SALES_DOCUMENT_TYPES,
} from '../lib/labels'

/** Kalendertag 'YYYY-MM-DD' (Europe/Berlin). */
export const zDay = z.iso.date({ error: 'Bitte ein gültiges Datum eingeben.' })

/** Uhrzeit 'HH:MM'. */
export const zTime = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, { error: 'Bitte eine Uhrzeit im Format HH:MM eingeben.' })

/** Menge im Gebinde in Tausendstel, größer als null. */
export const zUnitQty = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(1, { error: 'Die Menge muss größer als 0 sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

/** Menge im Gebinde in Tausendstel, null erlaubt. */
export const zUnitQtyOrZero = z
  .int({ error: 'Bitte eine Menge eingeben.' })
  .min(0, { error: 'Die Menge darf nicht negativ sein.' })
  .max(1_000_000_000, { error: 'Die Menge ist zu groß.' })

export const zReason = z
  .string({ error: 'Bitte geben Sie einen Grund an.' })
  .trim()
  .min(3, { error: 'Bitte geben Sie einen Grund an (mindestens 3 Zeichen).' })
  .max(500, { error: 'Der Grund ist zu lang (höchstens 500 Zeichen).' })

export const zNote = z.string().trim().max(500, { error: 'Die Notiz ist zu lang (höchstens 500 Zeichen).' }).nullish()

export const zLocationRef = z.object({ id: zId, code: z.string(), name: z.string() })
export const zCustomerRef = z.object({ id: zId, number: z.string().nullable(), name: z.string() })
export const zPerson = z.object({ id: zId, name: z.string() })
export const zDocumentRef = z.object({ id: zId, type: z.string(), number: z.string().nullable(), status: z.string(), statusLabel: z.string(), documentDate: z.string() })

/** Gezähltes Leergut: Pfandart und Stück in Tausendstel (3 Kästen = 3000). */
export const zEmptiesEntry = z.strictObject({
  depositTypeId: zId,
  emptiesQty: z
    .int({ error: 'Bitte eine Stückzahl eingeben.' })
    .min(1000, { error: 'Bitte mindestens 1 Stück angeben.' })
    .max(100_000_000, { error: 'Die Stückzahl ist zu groß.' })
    .multipleOf(1000, { error: 'Leergut wird in ganzen Stücken gezählt.' }),
})
